import { FC } from 'react';

import { useStats, UseStatsProps } from '../../../../shared/components';

type ArticlesButtonProps = UseStatsProps & {
  onClick: () => unknown;
};

export const ArticlesButton: FC<ArticlesButtonProps> = (props) => {
  const { nbHits } = useStats(props);

  return (
    <button className="sr-articles-button" aria-label="Articles" onClick={props.onClick}>
      {theme.locales.articlesSearch}{' '}
      <span className="hits">
        ({nbHits} {theme.locales.results})
      </span>
    </button>
  );
};
